module.exports = __webpack_public_path__ + "img/layout_top_tree_left.fad8de98.svg";